import React from 'react';
import { PushSpinner } from "react-spinners-kit";

const Spinner = () => (
    <div className="fullscreen">
        <PushSpinner size={30} color="#1B62C0" loading={true} />
    </div>
);

export default Spinner;